import React from 'react';


let SettingsList = props => {
    const {settings} = props;

    return <div>
        <div className="form-group row">
            <div className="col-sm-12">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>Option navn</th>
                        <th>Valgmuligheder</th>
                    </tr>
                    </thead>
                    <tbody>
                        {
                            settings.map((setting) => {
                                return <tr key={setting.id}>
                                    <td>{setting.id.split('_').join(' ')}</td>
                                    <td>{setting.isMultiple ? setting.value.join(', ') : setting.value}</td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
};

export default SettingsList;


// WEBPACK FOOTER //
// ./web/src/components/settings/SettingsList.jsx